var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwoFactorSidebarIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3352_4806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.25 1.83398L17.4167 3.66732M17.4167 3.66732L20.1667 6.41732L16.9583 9.62565L14.2083 6.87565M17.4167 3.66732L14.2083 6.87565M10.4408 10.6432C10.9142 11.1102 11.2904 11.6662 11.5479 12.2792C11.8055 12.8922 11.9392 13.5501 11.9414 14.2151C11.9437 14.88 11.8144 15.5388 11.5609 16.1535C11.3075 16.7682 10.935 17.3268 10.4648 17.797C9.99464 18.2671 9.4361 18.6396 8.82137 18.8931C8.20663 19.1465 7.54784 19.2758 6.88292 19.2736C6.218 19.2714 5.56009 19.1376 4.94707 18.8801C4.33404 18.6226 3.77802 18.2463 3.31101 17.773C2.39263 16.8221 1.88446 15.5486 1.89594 14.2267C1.90743 12.9048 2.43766 11.6402 3.37242 10.7055C4.30719 9.77072 5.5717 9.24049 6.89361 9.229C8.21552 9.21752 9.48906 9.72569 10.4399 10.6441L10.4408 10.6432ZM10.4408 10.6432L14.2083 6.87565",
    stroke: "#717171",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3352_4806"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoFactorSidebarIcon);
export default __webpack_public_path__ + "static/media/two_factor_sidebar_icon.4b7d639a12a6096858627d504f42d63d.svg";
export { ForwardRef as ReactComponent };